import {
  FAVORITE_WATCHLIST,
  useRemoteStorage,
  WHATS_NEW_SELECTED_WATCHLISTS,
} from '@terminal/hooks/use-remote-storage';
import { useInsightFeedFilters } from '@terminal/stores/use-insight-feed-filters/useInsightFeedFilters';

import { Watchlist } from './watchlist-types';

export const getValidWatchlistIds = (lists: Watchlist[]) =>
  new Set(lists.map(list => list.id));

export const reconcileWatchlistLinkedStorage = async (
  validIds: Set<string>
) => {
  const { items, storeItems, deleteItem } = useRemoteStorage.getState();
  const { selectedWatchlistIds, setSelectedWatchlistIds } =
    useInsightFeedFilters.getState();

  const favoriteId = items?.[FAVORITE_WATCHLIST];

  if (
    typeof favoriteId === 'string' &&
    favoriteId.length > 0 &&
    !validIds.has(favoriteId)
  ) {
    await deleteItem(FAVORITE_WATCHLIST);
  }

  // INSIGHT_FEED_SELECTED_WATCHLISTS is mirrored in `useInsightFeedFilters`.
  const nextInsightFeedSelection = new Set(
    [...selectedWatchlistIds].filter(id => validIds.has(id))
  );

  if (nextInsightFeedSelection.size !== selectedWatchlistIds.size) {
    setSelectedWatchlistIds(nextInsightFeedSelection);
  }

  const whatsNew = items?.[WHATS_NEW_SELECTED_WATCHLISTS] ?? [];
  const nextWhatsNew = whatsNew.filter(item => validIds.has(item.id));

  if (nextWhatsNew.length !== whatsNew.length) {
    await storeItems({ [WHATS_NEW_SELECTED_WATCHLISTS]: nextWhatsNew });
  }
};
